<div class="min-h-screen my-4 px-3 md:px-12 mx-auto">
  @if (storeInformation) {
    <section class="store fade-in">
      <div
        class="content"
        [style.--store-primary]="storeInformation.voucher_app_primary_color || '#4b5ae4'">
        @if (storeInformation.banner_image_path) {
          <div class="header-image">
            <img
              [src]="getImageUrl(storeInformation.banner_image_path)"
              [alt]="storeInformation.name + ' Banner'"
              loading="lazy" />
          </div>
        }
        <div class="logo-name-container">
          @if (storeInformation.logo_image_path) {
            <div class="shrink-0">
              <img
                [src]="getImageUrl(storeInformation.logo_image_path)"
                [alt]="storeInformation.name + ' Logo'"
                class="storefront-logo h-16 w-16 md:h-20 md:w-20 object-cover rounded-full border-3"
                loading="lazy" />
            </div>
          }
          <div class="name">
            <h2 class="text-3xl md:text-4xl font-bold mb-2">
              {{ storeInformation.name }}
            </h2>
            <p>
              {{ storeInformation.zip }} {{ storeInformation.city }}, {{ storeInformation.street }}
              @if (storeInformation.website) {
                <p>
                  <a
                    [href]="storeInformation.website"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="store-link hover:underline"
                    >{{
                      storeInformation.website.replace('http://', '').replace('https://', '')
                    }}</a
                  >
                </p>
              }
            </p>
          </div>
        </div>
        <p #storeDescription class="store-description" [class.collapsed]="!descriptionExpanded">
          {{ descriptionExpanded ? storeInformation.description : truncatedText }}
          @if (isTruncated && !descriptionExpanded) {
            <span class="desc-ellipsis">…</span>
          }
          @if (isTruncated || descriptionExpanded) {
            <button type="button" class="description-toggle" (click)="toggleDescription()">
              {{ descriptionExpanded ? 'weniger anzeigen' : 'mehr anzeigen' }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
                [class.expanded]="descriptionExpanded">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
          }
        </p>
        <div class="voucher-section">
          <div class="voucher-column">
            <!-- hideSteps: the storefront renders its own "So einfach geht's" panel below. -->
            @if (storeInformation) {
              <schenkwerk-voucher [hideSteps]="true" [storeId]="storeInformation.public_id">
              </schenkwerk-voucher>
            }
          </div>
          <aside class="steps-panel">
            <h3 class="steps-panel-title">So einfach geht's</h3>
            <p class="steps-panel-subtitle">Dein Gutschein in drei Schritten</p>
            <ol class="steps-list">
              <li class="step-item">
                <div class="step-icon" [ngStyle]="stepIconStyle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1.6">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                  </svg>
                </div>
                <div class="step-content">
                  <span class="step-label">Schritt 1</span>
                  <h4>Gutschein aussuchen</h4>
                  <p>
                    Such dir aus, was du verschenken möchtest, und leg den Gutschein in den
                    Warenkorb. Wenn du magst, schreibst du noch eine persönliche Nachricht für die
                    beschenkte Person dazu.
                  </p>
                </div>
              </li>
              <li class="step-item">
                <div class="step-icon" [ngStyle]="stepIconStyle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1.6">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                  </svg>
                </div>
                <div class="step-content">
                  <span class="step-label">Schritt 2</span>
                  <h4>Bequem bezahlen</h4>
                  <p>
                    Ob Visa, Mastercard, Apple Pay, Google Pay oder Amazon Pay – zahl so, wie du
                    magst. Deine Daten werden dabei immer verschlüsselt übertragen.
                  </p>
                </div>
              </li>
              <li class="step-item">
                <div class="step-icon" [ngStyle]="stepIconStyle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1.6">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                  </svg>
                </div>
                <div class="step-content">
                  <span class="step-label">Schritt 3</span>
                  <h4>Sofort im Postfach</h4>
                  <p>
                    Schon wenige Sekunden später liegt dein Gutschein als PDF in deinem
                    E-Mail-Postfach – ganz ohne Versandkosten und ohne Warten.
                  </p>
                </div>
              </li>
            </ol>
          </aside>
        </div>
        <!-- Redemption locations: a Verbund lists its shops next to the map, a single shop shows its own pin -->
        @if (locationsLoaded) {
          @if (redemptionLocations.length > 0) {
            <app-redemption-map class="locations-section" [locations]="redemptionLocations" />
          } @else if (storeLocation) {
            <app-redemption-map
              class="locations-section"
              [locations]="[storeLocation]"
              [showList]="false" />
          } @else {
            <div class="address-container">
              <p class="text-gray-600 text-base">
                <span class="font-bold inline-block mb-1">{{ storeInformation.name }}</span> <br />
                {{ storeInformation.street }} <br />
                {{ storeInformation.zip }} {{ storeInformation.city }}
              </p>
            </div>
          }
        }
      </div>
    </section>
  }

  @if (errorMessage) {
    <div class="error-message">
      <div class="container flex items-center min-h-screen px-6 py-12 mx-auto">
        <div>
          <p class="text-sm font-medium text-blue-500">404 error</p>
          <h1 class="mt-3 text-2xl font-semibold text-gray-800 md:text-3xl">
            Leider nicht gefunden...
          </h1>
          <p class="mt-4 text-gray-500">
            Sorry, die Seite, die du suchst, existiert leider nicht oder wurde verschoben.
          </p>
          <div class="flex items-center mt-6 gap-x-3">
            <a href="https://www.schenkwerk.com" rel="noopener noreferrer">
              <button
                class="flex gap-4 w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 bg-blue-500 rounded-lg shrink-0 sm:w-auto hover:bg-blue-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5 rtl:rotate-180">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                </svg>
                Zur Startseite
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  }
</div>
